var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.checked?_vm.CheckboxOnIcon:_vm.CheckboxIcon},on:{"click":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }